import { render, staticRenderFns } from "./BuyerClue.vue?vue&type=template&id=52ca1320&scoped=true&"
import script from "./BuyerClue.vue?vue&type=script&lang=js&"
export * from "./BuyerClue.vue?vue&type=script&lang=js&"
import style0 from "./BuyerClue.vue?vue&type=style&index=0&id=52ca1320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ca1320",
  null
  
)

export default component.exports